import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import QuestionForm from "../../ui/QuestionForm/QuestionForm";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  getEditingQuestionAsync,
  editQuestionAsync,
  clearQuestionForm
} from "../../../redux/actions/editQuestion";
import { openCancelModal, closeCancelModal } from "../../../redux/actions/ui";

const mapStateToProps = state => ({
  ...state.editQuestion,
  cancelModal: state.ui.cancelModal,
});

const mapDispatchToProps = dispatch => ({
  openCancelModal: () => dispatch(openCancelModal()),
  closeCancelModal: () => dispatch(closeCancelModal()),
  onGoBack: questionId => dispatch(push(`/question/${questionId}`)),
  onEditQuestion: questionId => dispatch(editQuestionAsync(questionId)),
  getQuestionInfo: questionId => dispatch(getEditingQuestionAsync(questionId)),
  clearForm: () => dispatch(clearQuestionForm()),
});

class EditQuestion extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    question: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    cancelModal: PropTypes.object.isRequired,
    openCancelModal: PropTypes.func.isRequired,
    closeCancelModal: PropTypes.func.isRequired,
    onEditQuestion: PropTypes.func.isRequired,
    getQuestionInfo: PropTypes.func.isRequired,
    clearForm: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { getQuestionInfo } = this.props;
    const questionId = this.props.match.params.questionId;
    getQuestionInfo(questionId);
  }

  /*
  askOrGoBack = () => {
    const { question, openCancelModal, onGoBack } = this.props;
    this.formIsEmpty(question) ? onGoBack() : openCancelModal();
  }
  */

  closeModalAndGo = () => {
    const { closeCancelModal, onGoBack, clearForm } = this.props;
    const questionId = this.props.match.params.questionId;
    closeCancelModal();
    clearForm();
    onGoBack(questionId);
  }

  render() {
    const { ready, loading, question, cancelModal, openCancelModal, closeCancelModal, onEditQuestion } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          confirmText="Остаться"
          cancelText="Покинуть страницу"
          modal={cancelModal}
          onSubmit={() => closeCancelModal()}
          onCancel={() => this.closeModalAndGo()}
        />
        <div className="page-header">
          {ready ? (
            <button type="button" className="btn btn-back" onClick={() => openCancelModal()}>
              <i aria-hidden="true" className="back-icon icon" />
              <span>Назад</span> 
            </button>
          ) : false}
        </div>
        <div className="page-content forms">
          <div className="form-header">Редактирование вопроса</div>
          {ready ? (
            <QuestionForm
              edit
              question={question}
              submitText="Сохранить изменения"
              onSubmit={() => onEditQuestion(question.id)}
            />
          ) : false}
          {loading ? (<Spinner />) : false}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(EditQuestion));
